import { Link } from "@shopify/hydrogen";
import NoImage from '~/assets/no_image_big.jpg';
import { CollectionItem } from "~/types";
import NoImageMultiStore from '~/assets/missingImage.jpg';
import { multiStore } from "../../../setup/settings/__product";

export default function CollectionCardItem({ collection }: { collection: CollectionItem }) {
    const getUrl = () => {
        const redirect = collection.RedirectUrl ?? "";
        if (redirect != '') return collection.RedirectUrl;
        else return `/collections/${collection.Handle}/products`;
    }

   
    return (
        <div className="containerCollection__item border-2">
            <Link to={getUrl()}>
                <div className="containerCollection__imagen-container flex justify-center items-center">
                    {collection.Square != ""
                        ? <img src={collection.Square} alt="#" />
                        : <img src={multiStore? NoImageMultiStore : NoImage} />
                    }
                </div>
                <h3 className="containerCollection__name text-center">{collection.Title}</h3>
            </Link>
        </div>
    )
}